import Header24_morph_mobile from './Header24_morph_mobile'
export default Header24_morph_mobile
